import React from "react";
import { Modal } from "react-bootstrap";

const VideoModal = ({ show, video, onHide, onPlay }) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    dialogClassName="video-modal-dialog"
    contentClassName="video-modal-content"
  >
    <Modal.Header closeButton closeVariant="white" className="video-modal-header">
      <Modal.Title className="video-modal-title">{video?.nombre}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="video-modal-body">
      <div className="video-modal-player">
        {video && (
          <video key={video.url} controls autoPlay onPlay={() => onPlay?.(video.url)}>
            <source src={video.url} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        )}
      </div>
    </Modal.Body>
  </Modal>
);

export default VideoModal;
